export default __webpack_public_path__ + "static/media/Flag_of_Lebanon.311d833b.svg";